module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1007-9684f6e21257582310e459384bf2e984.png";